'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _reduxActions = require('redux-actions');

var _tracking = require('../actions/tracking');

var actions = _interopRequireWildcard(_tracking);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapGran = 1;

exports['default'] = (0, _reduxActions.handleActions)((0, _defineProperty3['default'])({}, actions.setVideoPosSeen, function (state, action) {

  var margin = 3;
  var _action$payload = action.payload,
      videoId = _action$payload.videoId,
      second = _action$payload.second;


  var sv = state.seenVideos;
  var res = state;

  if (!sv[videoId]) sv = (0, _extends5['default'])({}, sv, (0, _defineProperty3['default'])({}, videoId, []));

  var list = enhance(sv[videoId], Math.max(0, second - 5), second);

  if (list !== sv[videoId]) sv = (0, _extends5['default'])({}, sv, (0, _defineProperty3['default'])({}, videoId, list));

  if (sv !== state.seenVideos) return (0, _extends5['default'])({}, state, { seenVideos: sv });else return state;
}), {

  seenVideos: {}

});


function arrayToMap(arr) {

  var map = [];

  arr.forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray3['default'])(_ref, 2),
        start = _ref2[0],
        end = _ref2[1];

    start = Math.round(start / mapGran);
    end = Math.round(end / mapGran);

    for (var i = start; i <= end; i++) {
      map[i] = true;
    }
  });

  return map;
}

function mapToArray(map) {

  if (!map.length) return [];

  map = [].concat((0, _toConsumableArray3['default'])(map), [false]); // Abschluss muss existieren

  var res = [];

  var start = 0;
  var i = 0;
  var showtime = false;

  while (++i < map.length) {

    if (showtime && !map[i]) {

      res.push([mapGran * start, mapGran * (i - 1)]);

      showtime = false;
    }

    if (!showtime && map[i]) {

      start = i;
      showtime = true;
    }
  }

  return res;
}

function enhance(arr, start, end) {

  var res = mapToArray(arrayToMap([].concat((0, _toConsumableArray3['default'])(arr), [[start, end]])));

  if ((0, _stringify2['default'])(arr) === (0, _stringify2['default'])(res)) return arr;else return res;
}


//////////////////
// WEBPACK FOOTER
// ./program/frontend/reducers/tracking.js
// module id = 871
// module chunks = 0